export enum DeliveryStatus {
    active = "active",
    delivered = "delivered",
    canceled = "canceled",
    dropAllowed = "dropAllowed"
}
